module.exports = __webpack_public_path__ + "static/media/farm.8ffe990c.svg";